<template>
  <div class="button-group" >
     <div class="button-container">
       <el-button v-for="btn in permissionButtons" class="button-item" :key="btn.code" type="primary"  @click="btnClick(btn.code)" size="small">{{btn.name}} </el-button>
      </div>
  </div>
</template>
<script>
import buttons from '@/components/mixin/button'
export default {
  mixins: [buttons]
}
</script>
